import { useMemo } from "react";
import { IClip, TClip, IClipWithTags, TTags } from "MVVM/@types";

type ClipWithPossibleTags = IClip | TClip | IClipWithTags | any;

export const checkIsTop5Clip = (
  clip?: ClipWithPossibleTags,
  tagKey?: string | string[],
): boolean => {
  if (!clip) return false;

  const tagKeys = Array.isArray(tagKey)
    ? tagKey
    : [tagKey ?? "INTERNAL_FEATURED"];

  if (clip.clipProperties) {
    return clip.clipProperties.some(
      (tag: TTags) =>
        tag.key && tagKeys.includes(tag.key) && tag.value === "TOP_5",
    );
  }

  if (clip.tags) {
    return clip.tags.some(
      (tag: { key: string; value: string }) =>
        tag.key && tagKeys.includes(tag.key) && tag.value === "TOP_5",
    );
  }

  if (clip.metadata) {
    return clip.metadata.some(
      (tag: { key: string; value: string }) =>
        tag.key && tagKeys.includes(tag.key) && tag.value === "TOP_5",
    );
  }

  return false;
};

export const useIsTop5Clip = (
  clip?: ClipWithPossibleTags,
  tagKey?: string | string[],
) => {
  return useMemo(() => checkIsTop5Clip(clip, tagKey), [clip, tagKey]);
};
